<script setup>

import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TransactionsModals from "./TransactionsModals.vue";
import emitter from "../assets/js/eventBus";

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const minimizeSidebar = () => store.commit("sidebarMinimize");

const getRoute = (n) => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[n];
};


const openType = (type) => {
    emitter.emit('set-type', { data: type });
}


</script>
<template>
    <div class="col-12 fixed-bottom shadow-lg d-xl-none" v-bind:class="{
                                'd-none': (getRoute(1) === 'login' || getRoute(1) === 'cadastro'),
                                'bg-white': !darkMode,
                                'mm-bg-dark': darkMode,
                            }">
        <div class="row text-center">
            <div class="col-2_5">
                <router-link :to="'/inicio'">
                    <div class="col-12 mx-auto mm-item" v-bind:class="{
                                'active': getRoute(1) === 'inicio',
                                'darkmode': darkMode,
                            }">
                        <i 
                            class="fa-home" 
                           :class="getRoute(1) === 'inicio' ? 'fas' : 'fal'"
                        ></i>
                        <p class="mb-n1 fs-10">{{$t('message.menu.home')}}</p>
                    </div>
                </router-link>
            </div>
            <div class="col-2_5">
                <router-link :to="'/transacoes'">
                    <div class="col-12 mx-auto mm-item" v-bind:class="{
                                'active': getRoute(1) === 'transacoes',
                                'darkmode': darkMode,
                            }">
                            <i 
                            class="fa-money-bill-wave opacity-10" 
                            :class="getRoute(1) === 'transacoes' ? 'fas' : 'fal'"
                        ></i>
                        <p class="mb-n1 fs-10">{{$t('message.global.transaction', 1)}}</p>
                    </div>
                </router-link>
            </div>
            <div class="col-2_5">
                <div class="dropup-center centered dropup mm-item-drop">
                    <button class="btn btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fal fa-plus-circle"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('despesa')">
                                <i class="fas fa-minus me-2 text-danger">                                             
                                </i>{{$t('message.global.expense')}}</a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li>
                            <a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('receita')">
                                <i class="fal fa-plus me-2 text-success"></i>{{$t('message.global.revenue')}}
                            </a>
                        </li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item text-dark font-weight-bold" :class="darkMode ? 'darkmode' : ''" data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('transferência')">
                            <i class="fal fa-exchange-alt me-2 text-danger">
                            </i>{{$t('message.global.transfer')}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-2_5">
                <router-link :to="'/objetivos'">
                    <div class="col-12 mx-auto mm-item" v-bind:class="{
                                'active': getRoute(1) === 'objetivos',
                                'darkmode': darkMode,
                            }">
                            <i 
                            class="fa-bullseye-arrow opacity-10" 
                            :class="getRoute(1) === 'objetivos' ? 'fas' : 'fal'"
                        ></i>
                        <p class="mb-n1 fs-10">{{$t('message.global.objetive')}}</p>
                    </div>
                </router-link>
            </div>
            <div class="col-2_5">
                <div class="col-12 mx-auto mm-item" @click="minimizeSidebar">
                    <i 
                        class="fal fa-bars opacity-10" 
                        :class="darkMode ? 'text-white' : 'text-dark'"
                    ></i>
                    <p class="mb-n1 fs-10">{{$t('message.menu.menu')}}</p>
                </div>
            </div>
        </div>
    </div>

    <TransactionsModals />
</template>

<style>
    .mm-item{
        padding-bottom: 12px;
        padding-top: 12px;
        font-weight: 500;
    }

    .mm-item i{
        font-size: 1rem;
    }

    .mm-item p{
        font-weight: 500;
        font-size: 0.9rem;
    }

    .mm-item.active i{
        background-color: #0c2b3a;
        border-radius: 0.5rem;
        color: #d18536;
        padding-right: 15px;
        padding-left: 15px;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .mm-item-drop{
        padding-top: 12px;
    }

    .mm-item-drop i{
        font-size: 1rem;
    }

    .mm-item-drop .btn{
        background-color: #d18536;
        color: #fff;
    }

    .mm-item-drop .btn:focus, .mm-item-drop .btn:active, .mm-item-drop .btn:hover{
        background-color: #0c2b3a;
        color: #d18536;
    }

    .dropup .dropdown-menu:after{
        display: none;
    }

    .col-2_5 {
        flex: 0 0 auto;
        width: 20% !important;
    }
    
    .darkmode.mm-item.active i{
        background-color: #d18536;
        border-radius: 0.5rem;
        color: #121212;
        padding-right: 15px;
        padding-left: 15px;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .mm-item.active p{
        font-weight: 800;
        color: #0c2b3a;
    }

    .darkmode.mm-item.active p{
        font-weight: 800;
        color: #d18536;
    }
    
    .mm-bg-dark{
        background-color: #3d3d3d !important;
    }
</style>